var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
// libs
import React, { memo } from 'react';
// HOC
import withIconDefaults from './withIconDefaults';
function BidRupeeIcon(_a) {
    var { fillColor, opacity } = _a, props = __rest(_a, ["fillColor", "opacity"]);
    return (React.createElement("svg", Object.assign({ width: "7", height: "10", viewBox: "0 0 7 10", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        React.createElement("path", { d: "M4.5 10L0.694444 6.05556V5.13889H2.5C3.02778 5.13889 3.49074 4.96759 3.88889 4.625C4.28704 4.28241 4.51852 3.80556 4.58333 3.19444H0V2.36111H4.51389C4.39352 1.91667 4.14583 1.55093 3.77083 1.26389C3.39583 0.976852 2.97222 0.833333 2.5 0.833333H0V0H6.66667V0.833333H4.52778C4.74074 1.01852 4.9213 1.25463 5.06944 1.54167C5.21759 1.8287 5.32407 2.10185 5.38889 2.36111H6.66667V3.19444H5.41667C5.34259 4.03704 5.03009 4.71065 4.47917 5.21528C3.92824 5.71991 3.26852 5.97222 2.5 5.97222H1.77778L5.65278 10H4.5Z", fill: fillColor, fillOpacity: opacity })));
}
export default memo(withIconDefaults(BidRupeeIcon));
